export default "__VITE_ASSET__6dZeb$OJ__"